"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var Styled = _interopRequireWildcard(require("./styles/IconAutoTopUp.style"));
var _ruleSet = require("../../ruleSet");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var IconAutoTopUp = function IconAutoTopUp(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.46 19.531h3m-3-2.562c0-.864-2.015-1.563-4.5-1.563-2.483 0-4.5.7-4.5 1.563s2.017 1.562 4.5 1.562c2.485 0 4.5-.699 4.5-1.562Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.46 16.969v2.949c-.589.691-2.374 1.05-4.5 1.05-2.124 0-3.913-.5-4.5-1.187v-2.875",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.46 20.41v2c.587.688 2.376 1.125 4.5 1.125 2.126 0 3.911-.312 4.5-1v-2.5s0-.5-1-.5m7.04-7.504v7.305a2.164 2.164 0 0 1-2.164 2.164h-3.719M6.5 15.309V4.664C6.5 3.47 7.469 2.5 8.664 2.5H17.5v3.531",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.527 5.89-7.703 7.633-2.945-2.945",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};
IconAutoTopUp.displayName = "IconAutoTopUp";
var _default = IconAutoTopUp;
exports["default"] = _default;